import PurchaseOrders from "../../../laboratory/purchaseOrders";

// purchase orders of the branch (requested by the laboratory), approved here by the manager
export default function PurchaseRequests() {
  return <PurchaseOrders approver />;
}
